import React from 'react';
import { Typography, useMediaQuery } from '@mui/material';
import { Theme, useTheme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import classNames from 'classnames';
import { RiCheckLine } from 'react-icons/ri';
import { useTranslation } from 'services/localization/useTranslation';

const RentalCardPreparedStatus = () => {
	const { t } = useTranslation();
	const classes = useStyles();
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	return (
		<div className={classNames(classes.statusDiv, classes.preparedStatus)}>
			<RiCheckLine size={22} className={classes.preparedIcon} />
			{!isMobile && <Typography variant="body2">{t('rentals.prepared', 'Prepared')}</Typography>}
		</div>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		statusDiv: {
			padding: theme.spacing(1),
			alignItems: 'center',
			display: 'flex',
		},
		preparedStatus: {
			backgroundColor: theme.palette.background.secondary,
		},
		preparedIcon: {
			marginRight: theme.spacing(1),
			[theme.breakpoints.down('md')]: {
				marginRight: 0,
			},
		},
	}),
);

export default RentalCardPreparedStatus;
